module.exports = __webpack_public_path__ + "static/media/chem_eng_explain.4038d61e.jpg";